import { render } from "./Hospital.vue?vue&type=template&id=6f99240f"
import script from "./Hospital.vue?vue&type=script&lang=js"
export * from "./Hospital.vue?vue&type=script&lang=js"
script.render = render

export default script